import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import CategoryGrid from './components/CategoryGrid';
import HowItWorks from './components/HowItWorks';
import ComparisonSection from './components/ComparisonSection';
import ProductGrid from './components/ProductGrid';
import TestimonialSection from './components/TestimonialSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import LatestArticles from './components/LatestArticles';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://vigorbuy.website';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  url: siteUrl,
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What is the Vigorbuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The Vigorbuy Spreadsheet is an organized directory of verified product links, shopping guides, QC tips, and updated collections. It helps shoppers discover products across multiple categories — from shoes and hoodies to bags and accessories — all in one convenient resource.',
      },
    },
    {
      '@type': 'Question',
      name: 'Is the Vigorbuy Spreadsheet safe to use?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes. The Vigorbuy Spreadsheet is an independent informational resource designed to improve your shopping experience. We provide verified product links, detailed quality check guides, and safety tips.',
      },
    },
    {
      '@type': 'Question',
      name: 'How often is the Vigorbuy Spreadsheet updated?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The Vigorbuy Spreadsheet is updated weekly with new products, refreshed links, and the latest shopping guides.',
      },
    },
    {
      '@type': 'Question',
      name: 'Is the Vigorbuy Spreadsheet free?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Absolutely. The Vigorbuy Spreadsheet is completely free to access. There is no registration required, no subscription fees, and no hidden costs.',
      },
    },
    {
      '@type': 'Question',
      name: 'What categories are available in the Vigorbuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'The updated vigorbuy spreadsheet covers 14 main categories: Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear/Underpants, Jersey, Accessories, Bags, Belts, Perfumes, and Other Stuff.',
      },
    },
    {
      '@type': 'Question',
      name: 'How do I use the Vigorbuy Spreadsheet effectively?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Start by browsing the category that interests you. Use the dropdown menu to navigate between categories. Read our buying guides and QC tips. Compare product details across listings and click through to Kaspreadsheet to shop.',
      },
    },
  ],
};

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Vigorbuy Spreadsheet Directory — Updated Products & Guides',
  description: 'Explore the latest Vigorbuy Spreadsheet with verified product links, shopping guides, QC tips, shipping advice, and updated collections.',
  url: siteUrl,
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Vigorbuy',
  url: siteUrl,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg',
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <Navbar transparent />
      <main>
        <HeroSection />
        <TrustBar />
        <CategoryGrid />
        <HowItWorks />
        <ComparisonSection />
        <ProductGrid />
        <TestimonialSection />
        <FAQSection />
        <LatestArticles />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}